export const payrollCaseRegistry = {
  isFirstCase: ({ payrollTypes, payItems }) =>
    payrollTypes === "BP" && payItems === "General Payroll",

  isSecondCase: ({ payrollTypes, jobTypeVal, payItems }) =>
    payrollTypes === "BP" &&
    jobTypeVal !== "Job Order" &&
    payItems === "Addendum Payroll",

  isThirdCase: ({ payrollTypes, payItems }) =>
    payrollTypes === "BP" && payItems === "Addendum Back-Pay",

  isFourthCase: ({ payrollTypes, payItems }) =>
    payrollTypes === "AP" &&
    (payItems === "General Payroll" || payItems === "Newly-Hired"),

  isFifthCase: ({ payrollTypes, jobTypeVal, payItems }) =>
    payrollTypes === "BP" &&
    jobTypeVal === "Job Order" &&
    payItems === "Salary",

  isSixthCase: ({ payrollTypes, jobTypeVal, payItems }) =>
    payrollTypes === "BP" &&
    jobTypeVal === "Job Order" &&
    payItems === "Addendum Payroll",

  isSeventhCase: ({ payrollTypes, jobTypeVal, payItems }) =>
    payrollTypes === "IP" &&
    jobTypeVal !== "Job Order" &&
    (payItems === "Initial" || payItems === "Last"),
  isEightCase: ({ payrollTypes, jobTypeVal, payItems }) =>
    payrollTypes === "IP" &&
    (payItems === "Initial AP" || payItems === "Last AP"),
  isNinthCase: ({ payrollTypes, payItems }) =>
    payrollTypes === "IP" && payItems === "Rata",
  isTenthCase: ({ payrollTypes, payItems }) =>
    payrollTypes === "IP" && payItems === "SalaryDiffBasic",
  isEleventhCase: ({ payrollTypes, jobTypeVal, payItems }) =>
    payrollTypes === "IP" &&
    jobTypeVal === "Job Order" &&
    (payItems === "Initial" || payItems === "Last"),
  isTwelvethCase: ({ payrollTypes, payItems }) =>
    payrollTypes === "AP" && payItems === "Back-Pay",
  isTirteenthCase: ({ payrollTypes, payItems }) =>
    payrollTypes === "SP" && payItems !== "20% Monthly Premium",
  isFourteenthCase: ({ payrollTypes, payItems }) =>
    payrollTypes === "SP" && payItems === "20% Monthly Premium",
};
